import React, { useState } from 'react';
import { Card, CardContent, TextField, MenuItem } from '@material-ui/core';
import authProvider from '../authProvider';
import ExperimentReportComponent from './components/ExperimentReportComponent';

const DATE_RANGE_OPTIONS = [
  { value: 0, label: 'Today' },
  { value: 2, label: 'Last 2 days' },
  { value: 3, label: 'Last 3 days' },
  { value: 5, label: 'Last 5 days' },
  { value: 7, label: 'Last 7 days' },
  { value: 8, label: 'Last 8 days' },
  { value: 10, label: 'Last 10 days' },
  { value: 15, label: 'Last 15 days' },
  { value: 30, label: 'Last 30 days' },
  { value: 'custom', label: 'Custom' }
];

const formatDate = (d) => d.toISOString().split('T')[0];

const ExperimentDashboard = (props) => {
  const [dateRange, setDateRange] = useState(7);
  const today = formatDate(new Date());
  const weekAgo = formatDate(new Date(Date.now() - 7 * 86400000));
  const [startDate, setStartDate] = useState(weekAgo);
  const [endDate, setEndDate] = useState(today);

  const isCustom = dateRange === 'custom';

  return (
    <div>
      <Card style={{ width: '100%' }} raised>
        <CardContent>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1em' }}>
            <div style={{ fontWeight: 'bolder' }}>Experiment Dashboard</div>
            <TextField
              select
              label="Date Range"
              value={dateRange}
              onChange={(e) => setDateRange(e.target.value)}
              style={{ minWidth: 180 }}
              InputLabelProps={{ style: { color: '#aaaaaa' } }}
              InputProps={{ style: { color: '#ffffff' } }}
              variant="outlined"
              size="small"
            >
              {DATE_RANGE_OPTIONS.map(opt => (
                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
              ))}
            </TextField>
            {isCustom && (
              <>
                <TextField
                  label="Start Date"
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  InputLabelProps={{ shrink: true, style: { color: '#aaaaaa' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                  variant="outlined"
                  size="small"
                />
                <TextField
                  label="End Date"
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  InputLabelProps={{ shrink: true, style: { color: '#aaaaaa' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                  variant="outlined"
                  size="small"
                />
              </>
            )}
          </div>
        </CardContent>
      </Card>
      <div style={{ height: '15px', backgroundColor: 'transparent' }} />
      <ExperimentReportComponent
        authProvider={authProvider}
        dateRange={dateRange}
        startDate={isCustom ? startDate : null}
        endDate={isCustom ? endDate : null}
      />
    </div>
  );
};

export default ExperimentDashboard;
